import { FormFieldGroup } from '@models/forms/form-field-group.model';

export const formTypes = [
  {
    name: 'Assisted',
    id: 1,
  },
  {
    name: 'Harbor',
    id: 2,
  },
];

export interface FormField {
  id: string;
  name: string;
  label: string;
  formFieldsetGroups: FormFieldGroup[];
  formReference: string;
}
